<template>
  <div>
    <section role="modal">
      <div
        class="modal fade"
        id="periodoAberturaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="periodoAberturaModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="periodoAberturaModalLabel">
                Período de entrega da Declaração
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: center; font-size: 1.6rem">
                    <strong> Atenção </strong>
                  </p>
                  <p style="text-align: justify">
                    O período para a entrega da Declaração de Bens via Central
                    do Servidor se encerrou. Aguarde um novo período ou envie um
                    email para
                    <strong>declaracaodebens@santos.sp.gov.br</strong> para
                    esclarecer suas dúvidas.
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                estilo="cheio-verde"
                rotulo="Estou ciente"
                icone="ok-modal"
                dismiss="modal"
              ></botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="modal">
      <div
        class="modal fade"
        id="leiModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="leiModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="leiModalLabel">
                Declarações de Bens e Valores Anteriores
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Após 30 (trinta) dias, contados da data limite fixada pela
                    Secretaria da Receita Federal do Ministério da Fazenda,
                    todos os servidores municipais no exercício de mandatos,
                    cargos, funções ou empregos em órgãos da administração
                    direta e indireta devem efetuar a Declaração Anual de Bens e
                    Valores, prevista no Decreto Municipal nº 7.517/2016. O
                    informe é feito exclusivamente por meio do sistema
                    eletrônico, disponibilizado no site da Prefeitura através da
                    Secretaria de Finanças e Gestão. Todos os bens e valores de propriedade
                    do servidor (imóveis, móveis, dinheiro, títulos, ações,
                    investimentos financeiros, participações societárias e
                    qualquer outra espécie de bens e valores patrimoniais
                    existentes no país ou no exterior) devem ser informados.
                    Também fazem parte da declaração, bens e valores
                    relacionados ao cônjuge ou companheiro (a), aos filhos ou a
                    outras pessoas que tenham dependência econômica do
                    declarante.
                  </p>
                  <p>
                    <strong>
                      Atenção: o servidor que não entregar o documento no prazo
                      previsto tem a sua remuneração suspensa e está sujeito a
                      outras medidas administrativas.
                    </strong>
                  </p>
                  <p>
                    Lembrando que aposentados e pensionistas estão isentos da
                    Declaração Anual de Bens e Valores.
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                estilo="cheio-verde"
                rotulo="Estou ciente"
                icone="ok-modal"
                dismiss="modal"
              ></botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="modal">
      <div
        class="modal fade"
        id="salvaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="salvaModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="salvaModalLabel">
                Entregar Declaraçao
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    Deseja
                    <strong>entregar</strong> sua declaração agora ou prefere
                    apenas salvar um <strong>rascunho</strong>?
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                tipo="button"
                estilo="cheio-cinza"
                rotulo="Cancelar"
                icone="cancela-modal"
                dismiss="modal"
                @clicado="limpaModal()"
              ></botao>
              <botao
                tipo="button"
                estilo="vazado-verde"
                rotulo="Rascunho"
                icone="fa-pencil-square-o fa-lg"
                @clicado="salva(declaracaoModal, 'PENDENTE')"
              ></botao>
              <botao
                tipo="button"
                estilo="cheio-verde"
                rotulo="Entregar"
                icone="ok-modal"
                @clicado="salva(declaracaoModal, 'FINALIZADA')"
              ></botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="modal">
      <div
        class="modal fade"
        id="retificaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="retificaModalLabel"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title" id="retificaModalLabel">
                Retificar Declaração
              </h4>
            </div>
            <div class="modal-body">
              <div class="row row-field" style="padding-bottom: 15px">
                <div class="col-md-12 col-sm-12">
                  <p style="text-align: justify">
                    <strong>Atenção</strong> A declaração só pode ser retificada
                    <strong>uma vez</strong>. Deseja retificar agora?
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <botao
                tipo="button"
                estilo="cheio-cinza"
                rotulo="Cancelar"
                icone="cancela-modal"
                dismiss="modal"
                @clicado="limpaModal()"
              ></botao>
              <botao
                tipo="button"
                estilo="cheio-verde"
                rotulo="Retificar"
                icone="ok-modal"
                @clicado="salvaRetificada(declaracaoModal)"
              ></botao>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="side-modal">
      <side-modal :sides="navs">
        <template :slot="navs[0].identidade">
          <div class="side-body">
            <div class="row row-field">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <p>
                    <strong>Eu declaro...</strong>
                    <esconde-div>
                      <p style="text-align: justify">
                        Declaro, sob as penas da lei, que as informações aqui
                        prestadas são verdadeiras, autorizando a Administração a
                        proceder, por meio eletrônico, à guarda das informações
                        constantes neste formulário, bem como das informações
                        posteriores que atualizarão a presente, resguardado o
                        sigilo destas. Em conformidade com o disposto nos
                        artigos 57 e 63, da Lei Orgânica do Município, com a
                        alteração dada pela Emenda nº 09 de 22/11/92, declaro
                        possuir na presente data os seguintes bens:
                      </p>
                    </esconde-div>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <p
                    v-if="
                      declaracaoModal.situacao == 'RETIFICADA' ||
                        declaracaoModal.situacao == 'FINALIZADA'
                    "
                  >
                    <strong>Entregue em</strong>
                    {{ declaracaoModal.dataDeclaracao | formataData }}
                  </p>
                  <p v-if="declaracaoModal.situacao == 'RETIFICADORA'">
                    <strong>Retificada em</strong>
                    {{ declaracaoModal.dataDeclaracao | formataData }}
                  </p>
                </div>
              </div>
              <div>
                <div v-if="carregandoItens">
                  <h2 class="carregando">Carregando...</h2>
                </div>
                <div v-else>
                  <div
                    class="alert alert-success"
                    role="alert"
                    style="text-align: center"
                    v-if="declaracaoModal.semBens"
                  >
                    <i class="fa fa-check fa-lg"></i>&nbsp;
                    <strong
                      >Você declarou não possuir bens nos termos da legislação
                      vigente.</strong
                    >
                  </div>
                  <div
                    class="alert alert-warning"
                    role="alert"
                    style="text-align: center; cursor: pointer"
                    @click="novoItem()"
                    v-else-if="!declaracaoModal.itens.length"
                  >
                    <i class="fa fa-flag-o fa-lg"></i>&nbsp; Você ainda não tem
                    bens declarados.
                    <span v-show="mostraCopiaAnteriorNoSideModal()">
                      <br />
                    </span>
                    Para começar, clique em NOVO.
                    <span v-show="mostraCopiaAnteriorNoSideModal()">
                      Ou importe dados clicando em DECLARAÇÃO ANTERIOR.
                    </span>
                  </div>
                  <table class="table table-striped table-hover" v-else>
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th class="hidden-xs">Descrição</th>
                        <th
                          :class="
                            declaracaoModal.situacao == 'EM_BRANCO'
                              ? 'hidden-xs'
                              : ''
                          "
                        >
                          Valor
                        </th>
                        <th
                          v-if="
                            mostraBotoesDeEdicaoNoSideModal(declaracaoModal)
                          "
                        >
                          &nbsp;
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in declaracaoModal.itens"
                        :key="declaracaoModal.itens.indexOf(item)"
                      >
                        <td>{{ item.tipo.descricao.toUpperCase() }}</td>
                        <td class="hidden-xs">
                          {{ item.descricao.toUpperCase() }}
                        </td>
                        <td
                          :class="
                            declaracaoModal.situacao == 'EM_BRANCO'
                              ? 'hidden-xs'
                              : ''
                          "
                        >
                          {{ item.valor | monetarioMask }}
                        </td>
                        <td
                          class="td-btns"
                          v-if="
                            mostraBotoesDeEdicaoNoSideModal(declaracaoModal)
                          "
                        >
                          <botao
                            estilo="vazado-vermelho-sm"
                            icone="exclui-tabela"
                            toggle
                            target
                            @clicado="apagaItem(item)"
                          ></botao>
                          <botao
                            estilo="vazado-cinza-sm"
                            icone="editar-tabela"
                            toggle
                            target
                            @clicado="editaItem(item)"
                          ></botao>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    class="col-xs-12 footer-controller-inner-modal"
                    v-if="mostraBotoesDeEdicaoNoSideModal(declaracaoModal)"
                  >
                    <botao
                      estilo="vazado-verde-dir"
                      rotulo="Novo"
                      icone="novo-modal"
                      toggle
                      target
                      @clicado="novoItem()"
                    ></botao>
                    <botao
                      estilo="vazado-verde-dir"
                      :rotulo="telaEhBigMobile ? 'S/ bens' : 'Sem bens'"
                      icone="cancela-modal"
                      toggle
                      target
                      @clicado="semBensModal()"
                      v-if="
                        !declaracaoModal.itens.length &&
                          !declaracaoModal.semBens
                      "
                    ></botao>
                    <botao
                      estilo="vazado-verde-dir"
                      :rotulo="
                        telaEhBigMobile ? 'Decl. Ant.' : 'Declaração Anterior'
                      "
                      icone="fa-magic"
                      toggle
                      target
                      @clicado="copiaDeclaracaoAnterior()"
                      v-if="mostraCopiaAnteriorNoSideModal()"
                    ></botao>
                  </div>
                  <div
                    class="form-group"
                    v-if="mostraJustificativaNoSideModal(declaracaoModal)"
                  >
                    <label for="justificativa">
                      Observação ou justificativa (não obrigatório)
                    </label>
                    <textarea
                      name="justificativa"
                      id="justificativa"
                      rows="4"
                      class="form-control"
                      :readonly="
                        !mostraBotoesDeEdicaoNoSideModal(declaracaoModal)
                      "
                      v-model="declaracaoModal.justificativa"
                      maxlength="500"
                      @keyup="charCount()"
                    ></textarea>
                    <br />
                    <span>{{ totalCharacter }}/500</span>
                    <div v-if="totalCharacter == 500">
                      <br />
                      <span class="characterAlert"
                        >A justificativa deve conter no máximo 500
                        caracteres.</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="side-footer">
            <botao
              tipo="button"
              estilo="cheio-cinza"
              rotulo="Cancelar"
              icone="cancela-modal"
              @clicado="cancela()"
            ></botao>
            <botao
              tipo="button"
              estilo="cheio-verde"
              icone="ok-modal"
              :rotulo="
                declaracaoModal.situacao == 'RETIFICANTE'
                  ? 'Retificar'
                  : 'Salvar'
              "
              @clicado="
                declaracaoModal.situacao == 'RETIFICANTE'
                  ? abreEnviaModal(declaracaoModal, '#retificaModal')
                  : abreEnviaModal(declaracaoModal, '#salvaModal')
              "
              v-if="mostraBotoesDeEdicaoNoSideModal(declaracaoModal)"
            ></botao>
            <botao
              :estilo="
                declaracaoModal.situacao == 'RETIFICADA' ||
                declaracaoModal.situacao == 'FINALIZADA' ||
                declaracaoModal.situacao == 'RETIFICADORA'
                  ? 'cheio-verde'
                  : 'vazado-verde'
              "
              rotulo="Imprimir"
              icone="fa-print fa-lg"
              toggle
              target
              @clicado="imprime(declaracaoModal.id)"
              v-show="declaracaoModal.id"
            ></botao>
          </div>
        </template>
        <template :slot="navs[1].identidade">
          <div class="side-body">
            <div class="row">
              <form>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Tipo de Bem"
                    field="tipoBem"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <select
                      class="form-control"
                      name="tipoBem"
                      v-model="itemModal.tipo"
                      v-validate="'required'"
                      data-vv-as="Tipo de Bem"
                    >
                      <option value selected="selected">Escolha</option>
                      <option
                        v-for="tipo in tiposBens"
                        :value="tipo"
                        :key="tiposBens.indexOf(tipo)"
                      >
                        {{ `${tipo.descricao} (cód. IR - ${tipo.codigo})` }}
                      </option>
                    </select>
                  </field-validation>
                  <field-validation
                    css-class="col-md-6 col-sm-6"
                    label="Valor"
                    field="valor"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <money
                      type="text"
                      name="valor"
                      id="valor"
                      class="form-control"
                      v-model="itemModal.valor"
                      v-validate="{ is_not: 0 }"
                      data-vv-as="Valor"
                    />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <div class="col-md-6 col-sm-6">
                    <div class="form-group">
                      <label for="heranca">Herança</label>
                      <select
                        class="form-control"
                        id="heranca"
                        name="heranca"
                        v-model="itemModal.heranca"
                      >
                        <option :value="null" selected="true">Escolha</option>
                        <option :value="true">SIM</option>
                        <option :value="false">NÃO</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6">
                    <div class="form-group">
                      <label>Parceiro Econômico</label>
                      <select
                        class="form-control"
                        id="dependente"
                        v-model="itemModal.dependencia"
                        @change="incluiDependente(itemModal)"
                      >
                        <option :value="null" selected="true">Escolha</option>
                        <option
                          v-for="dependencia in dependencias"
                          :value="dependencia"
                          :key="dependencia.id"
                        >
                          {{ dependencia.dependente.nome }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div v-if="mostraAtualizarRenda" class="row row-field">
                  <field-validation
                    css-class="col-md-12 col-sm-12"
                    label="Renda Anual do Parceiro"
                    field="rendaAnual"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <money
                      type="text"
                      name="rendaAnual"
                      id="rendaAnual"
                      class="form-control"
                      v-model="rendaAnualDependenteModal"
                      v-validate="{ is_not: 0 }"
                      data-vv-as="Renda Anual"
                    />
                  </field-validation>
                </div>
                <div class="row row-field">
                  <field-validation
                    css-class="col-md-12 col-sm-12"
                    label="Descrição"
                    field="descricao"
                    :status="errors"
                    :custom-errors="apiErrors"
                    :show-icon="false"
                  >
                    <textarea
                      rows="4"
                      name="descricao"
                      id="descricao"
                      class="form-control"
                      v-model="itemModal.descricao"
                      v-validate="'required|max:500'"
                      data-vv-as="Descrição"
                    />
                  </field-validation>
                </div>
              </form>
            </div>
          </div>
          <div class="side-footer">
            <botao
              tipo="button"
              estilo="cheio-cinza"
              rotulo="Cancelar"
              icone="cancela-modal"
              @clicado="cancelaItem()"
            ></botao>
            <botao
              tipo="button"
              estilo="cheio-verde"
              rotulo="Incluir"
              icone="ok-modal"
              @clicado="validaItem()"
            ></botao>
          </div>
        </template>
      </side-modal>
    </section>
    <section role="table">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Declaração de Bens&nbsp;
                  <small>
                    <a @click="abreLeiModal()" style="cursor: pointer"
                      >(Por que devo declarar meus bens?)</a
                    >
                  </small>
                </h4>
                <div>
                  <table-loader :carregando="carregando">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center; cursor: pointer"
                      @click="novo(declaracao)"
                      v-if="declaracoes.length == 0"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Você ainda não
                      tem declarações de bens.
                    </div>
                    <table class="table table-striped table-hover" v-else>
                      <thead>
                        <tr>
                          <th>Ano Base</th>
                          <th class="hidden-xs">Data da Declaração</th>
                          <th>Situação</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="declaracaoItem in declaracoesOrdenadasDistintas"
                          :key="
                            declaracaoItem.competencia &&
                              declaracaoItem.competencia.ano +
                                declaracaoItem.competencia.mes +
                                declaracaoItem.dataDeclaracao +
                                declaracaoItem.situacao
                          "
                          :class="
                            declaracaoItem.situacao == 'EM_BRANCO'
                              ? 'situacao-pendente'
                              : ''
                          "
                        >
                          <td>
                            {{ obtemAnoBase(declaracaoItem.competencia) }}
                          </td>
                          <td
                            class="hidden-xs"
                            v-if="declaracaoItem.dataDeclaracao"
                          >
                            {{ declaracaoItem.dataDeclaracao | formataData }}
                          </td>
                          <td class="hidden-xs" v-else>
                            <i
                              class="fa fa-ellipsis-h fa-lg"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>{{ obtemSituacao(declaracaoItem.situacao) }}</td>
                          <td class="td-btns">
                            <botao
                              estilo="vazado-laranja-sm"
                              style="width: 83px"
                              :icone="
                                declaracaoItem.situacao == 'PENDENTE'
                                  ? 'editar-tabela'
                                  : 'fa-file-o fa-lg'
                              "
                              toggle
                              target
                              @clicado="novo(declaracaoItem)"
                              :disabled="
                                desabilitaEdicaoDasAtrasadas(declaracaoItem)
                              "
                              v-show="mostraNova(declaracaoItem)"
                              v-tooltip.left="'Declarar'"
                            ></botao>
                            <botao
                              estilo="vazado-cinza-sm"
                              style="width: 83px"
                              icone="editar-tabela"
                              toggle
                              target
                              @clicado="edita(declaracaoItem)"
                              v-show="mostraEditar(declaracaoItem)"
                              v-tooltip.right="'Editar'"
                            ></botao>
                            <span v-show="mostraRetificarVer(declaracaoItem)">
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="fa-wrench fa-lg"
                                toggle
                                target
                                @clicado="edita(declaracaoItem, 'RETIFICANTE')"
                                v-tooltip.left="'Retificar'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                toggle
                                target
                                @clicado="edita(declaracaoItem)"
                                v-tooltip.right="'Visualizar'"
                              ></botao>
                            </span>
                            <span v-show="mostraVisualizar(declaracaoItem)">
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="fa-history fa-lg"
                                toggle
                                target
                                @clicado="visualizaOriginal(declaracaoItem)"
                                v-tooltip.left="'Decl.Original'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                toggle
                                target
                                @clicado="edita(declaracaoItem)"
                                v-tooltip.right="'Retificada'"
                              ></botao>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-xs-12 footer-controller-inner">
                      <botao
                        estilo="cheio-verde-dir"
                        rotulo="Declarar"
                        icone="fa-file-o"
                        toggle
                        target
                        @clicado="novo(declaracao)"
                      ></botao>
                      <botao
                        estilo="vazado-verde-dir"
                        rotulo="Sem bens"
                        icone="cancela-modal"
                        v-if="
                          declaracoesOrdenadasDistintas[0].situacao ==
                            'EM_BRANCO'
                        "
                        toggle
                        target
                        @clicado="semBens(declaracao)"
                      ></botao>
                      <router-link to="/faq">
                        <botao
                          estilo="vazado-laranja-esq"
                          :rotulo="telaEhBigMobile ? '' : 'Faq'"
                          icone="fa fa-question-circle-o fa-lg"
                        ></botao>
                      </router-link>
                    </div>
                  </table-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import DeclaracoesService from '@/services/declaracoesService';
import TiposBensService from '@/services/enums/tiposBensService';
import DependenciasService from '@/services/dependenciasService';
import MesesCompetenciasService from '@/services/mesesCompetenciasService';
import obtemImpressao from '@/services/obtemImpressao';
import Declaracao from '@/domain/declaracao';
import Item from '@/domain/declaracao/item';
import Dependencia from '@/domain/dependencia';
import Renda from '@/domain/dependencia/renda';
import ArrayHelper from '@/helpers/ArrayHelper';
import StringHelper from '@/helpers/StringHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import Botao from '@/components/botao';
import SideModal from '@/components/side-modal';
import EscondeDiv from '@/components/esconde-div';
import TableLoader from '@/components/table-loader';
import moment from 'moment';

export default {
  name: 'Declaracoes',

  data() {
    return {
      autenticado: {},
      carregando: false,
      carregandoItens: false,
      declaracoes: [],
      declarante: {},
      declaracao: {},
      declaracaoModal: {},
      retificada: {},
      item: {},
      itemModal: {},
      tiposBens: [],
      dependencias: [],
      dependencia: {},
      competencias: [],
      rendaAnualDependenteModal: 0,
      totalCharacter: 0,
      mostraAtualizarRenda: false,
      apiErrors: null,
      navs: [
        {
          titulo: 'Declaração',
          subtitulo: 'Ano Referência',
          subtDetalhe: 'Ano anterior',
          largura: 900,
          identidade: 'declaracao',
          abreProximo: false,
          aberto: false,
        },
        {
          titulo: 'Declaração',
          subtitulo: 'Bens e Valores',
          subtDetalhe: 'Nova Declaração',
          largura: 600,
          identidade: 'item',
          abreProximo: false,
          aberto: false,
        },
      ],
    };
  },
  computed: {
    declaracoesOrdenadasDistintas() {
      if (this.declaracoes.length) {
        const declaracoes = this.declaracoes.sort((a, b) => {
          if (a.competencia.ano > b.competencia.ano) return -1;
          if (a.competencia.ano < b.competencia.ano) return 1;
          if (a.competencia.mes > b.competencia.mes) return -1;
          if (a.competencia.mes < b.competencia.mes) return 1;
          if (a.numeroRetificacao > b.numeroRetificacao) return -1;
          if (a.numeroRetificacao < b.numeroRetificacao) return 1;
        });
        const declaracoesComCompetenciaId = declaracoes.map(declaracao => {
          declaracao.competenciaId = declaracao.competencia.id;
        });
        const distintas = ArrayHelper.distinctArray(
          declaracoes,
          'competenciaId',
        );

        return distintas;
      }
      let listaComPrimeiraDeclaracao = [this.declaracao];
      listaComPrimeiraDeclaracao[0].competencia = {
        ano: (moment().year() - 1).toString(),
      };

      return listaComPrimeiraDeclaracao;
    },
    competenciasOrdenadas() {
      let competencias = [];
      if (this.competencias.length) {
        competencias = this.competencias.sort((a, b) => {
          if (a.ano > b.ano) return 1;
          if (a.ano < b.ano) return -1;
          if (a.mes > b.mes) return 1;
          if (a.mes < b.mes) return -1;
        });
      }

      return competencias;
    },
    rendaAnualStatus() {
      return this.rendaAnualDependenteModal ? 'alert-success' : 'alert-danger';
    },
    telaEhBigMobile() {
      return window.innerWidth > 405 && window.innerWidth < 590;
    },
  },
  methods: {
    async imprime(id) {
      const endpoint = `declaracoes-bens/${id}/impresso`;

      try {
        await obtemImpressao(endpoint);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    obtemAnoBase(competencia) {
      if (competencia) {
        return competencia.mes === 7
          ? competencia.ano - 1 + ' Sem.'
          : competencia.ano - 1;
      }

      return '';
    },
    obtemSituacao(situacao) {
      switch (situacao) {
        case 'FINALIZADA':
          return 'ENTREGUE';
          break;
        case 'EM_BRANCO':
          return 'NÃO ENTREGUE';
          break;
        case 'PENDENTE':
          return 'EM ELABORAÇÃO';
          break;
        case 'RETIFICADA':
          return 'RETIFICADA';
          break;
        case 'RETIFICADORA':
          return 'COM RETIFICAÇÃO';
          break;
        default:
          return 'NÃO INFORMADA';
          break;
      }
    },
    abreModal(identidade) {
      this.$emit('abreModal', identidade);
    },
    fechaModal(identidade) {
      this.$emit('fechaModal', identidade);
    },
    trataMensagemSucesso(situacao, acao) {
      switch (situacao) {
        case 'PENDENTE':
          this.$root.$refs.toastr.w(
            `Essa declaração foi ${acao} mas ainda NÃO FOI ENTREGUE`,
            'Atenção',
          );
          break;
        case 'FINALIZADA':
          this.$root.$refs.toastr.s('Declaração entregue', 'Sucesso');
          break;
        case 'RETIFICADA':
          this.$root.$refs.toastr.s('Declaração retificada', 'Sucesso');
          break;
        default:
          this.$root.$refs.toastr.s(`Informação ${acao}`, 'Sucesso');
          break;
      }
    },

    // Métodos de apresentação de componentes
    mostraNova(declaracao) {
      return declaracao.situacao == 'EM_BRANCO';
    },
    mostraEditar(declaracao) {
      return declaracao.situacao === 'PENDENTE';
    },
    mostraRetificarVer(declaracao) {
      return (
        declaracao.situacao === 'FINALIZADA' && !declaracao.numeroRetificacao
      );
    },
    mostraVisualizar(declaracao) {
      return (
        declaracao.situacao == 'RETIFICADA' ||
        declaracao.situacao == 'RETIFICADORA'
      );
    },
    desabilitaEdicaoDasAtrasadas(declaracaoItem) {
      return this.declaracao.competencia
        ? declaracaoItem.competencia.id != this.declaracao.competencia.id
        : true;
    },
    mostraBotoesDeEdicaoNoSideModal(declaracao) {
      return declaracao.situacao != 'RETIFICADA' &&
        declaracao.situacao != 'FINALIZADA' &&
        declaracao.situacao != 'RETIFICADORA'
        ? true
        : false;
    },
    mostraCopiaAnteriorNoSideModal() {
      return this.declaracoesOrdenadasDistintas.length > 1 &&
        this.declaracaoModal.itens.length <= 0 &&
        this.declaracaoModal.situacao == 'EM_BRANCO'
        ? true
        : false;
    },
    mostraJustificativaNoSideModal(declaracao) {
      if (
        !this.mostraBotoesDeEdicaoNoSideModal(declaracao) &&
        !declaracao.justificativa
      )
        return false;
      if (!declaracao.itens.length) return false;
      return true;
    },

    // Métodos da primeira tela
    novo(declaracao) {
      this.errors.clear();

      this.validaJaDeclarado(declaracao)
        ? this.$root.$refs.toastr.i(
            'Você já efetuou suas entregas de declaração anual de bens. Obrigado.',
            'Atenção',
          )
        : this.edita(declaracao);
    },
    async edita(declaracao, situacao) {
      const situacaoAtual = situacao || declaracao.situacao;

      if (this.bloqueiaEntregaPorData(declaracao, situacaoAtual)) return;

      if (declaracao.id) {
        await this.listaItens(declaracao.id);
      } else {
        declaracao.index = this.declaracoes.indexOf(declaracao);
        this.declaracaoModal = JSON.parse(JSON.stringify(declaracao));
      }

      this.declaracaoModal.dataDeclaracao = moment().format('YYYY-MM-DD');

      if (!!situacao) {
        this.declaracaoModal.index = this.declaracoes.indexOf(declaracao);
        this.corrigeRetificada(this.declaracaoModal);
      }

      this.navs[0].subtDetalhe = situacao
        ? 'Retificação ' + this.valoraSubdetalheNav0()
        : this.valoraSubdetalheNav0();

      this.abreModal('declaracao');
    },
    async visualizaOriginal(declaracao) {
      await this.listaItens(declaracao.idDeclaracaoBensRetificada);

      this.navs[0].subtDetalhe = this.valoraSubdetalheNav0();

      this.abreModal('declaracao');
    },
    valoraSubdetalheNav0() {
      if (this.declaracaoModal.competencia.mes === 7) {
        return this.declaracaoModal.competencia.ano - 1 + ' Semestral';
      }
      return (this.declaracaoModal.competencia.ano - 1).toString();
    },

    // Métodos do modal Declaração
    copiaDeclaracaoAnterior() {
      const indexAtual = this.declaracoesOrdenadasDistintas.indexOf(
        this.declaracao,
      );
      const indexAnterior = indexAtual + 1;
      const declaracaoPassada = this.declaracoesOrdenadasDistintas[
        indexAnterior
      ];
      const competenciaMes = this.declaracaoModal.competencia.mes;

      this.listaItens(declaracaoPassada.id).then(() => {
        this.corrigeCopiaDaAnterior(competenciaMes, indexAtual);
        this.declaracaoModal.itens.forEach(item => {
          if (this.validaRendaDependente(item)) {
            return;
          }
          this.editaItem(item);
          Vue.nextTick().then(() => this.solicitaAtualizarRenda());
        });
      });
    },
    corrigeCopiaDaAnterior(competenciaMes, index) {
      let competenciaDesteAno = {};

      if (competenciaMes === 7) {
        competenciaDesteAno = this.competencias.find(
          competencia =>
            competencia.ano === this.declaracaoModal.competencia.ano &&
            competencia.mes === 7,
        );
      } else {
        competenciaDesteAno = this.competencias.find(
          competencia =>
            competencia.ano === this.declaracaoModal.competencia.ano + 1 &&
            competencia.mes === 1,
        );
      }
      this.declaracaoModal.competencia = competenciaDesteAno;
      this.declaracaoModal.dataDeclaracao = moment().format('YYYY-MM-DD');
      this.declaracaoModal.situacao = 'EM_BRANCO';
      this.declaracaoModal.idDeclaracaoBensRetificada = null;
      this.declaracaoModal.id = null;
      this.declaracaoModal.index = index;
      this.declaracaoModal.numeroRetificacao = 0;
      this.declaracaoModal.itens.map(item => (item.id = null));
    },
    corrigeRetificada(declaracao) {
      declaracao.dataDeclaracao = moment().format('YYYY-MM-DD');
      declaracao.situacao = 'RETIFICANTE';
      declaracao.numeroRetificacao++;
      declaracao.idDeclaracaoBensRetificada = declaracao.id;
      declaracao.id = null;
      declaracao.itens.map(item => (item.id = null));
    },
    salva(declaracao, situacao) {
      this.declaracao = declaracao;
      this.gerenciaDeclaracao(situacao);
      jQuery('#salvaModal').modal('hide');
      this.limpaModal();
    },
    salvaRetificada(declaracao) {
      this.gerenciaDeclaracao('RETIFICADORA');
      jQuery('#retificaModal').modal('hide');
      this.limpaModal();
    },
    gerenciaDeclaracao(situacao) {
      const retificante = this.declaracaoModal.situacao === 'RETIFICANTE';
      if (retificante) {
        this.declaracaoModal.situacao = 'RETIFICADORA';
        this.gravaDeclaracao(this.declaracaoModal);
        return;
      }
      this.declaracao.situacao = situacao;
      this.gravaDeclaracao(this.declaracao);
    },
    async gravaDeclaracao(declaracao) {
      try {
        let acao;
        if (declaracao.id) {
          await DeclaracoesService.atualiza(declaracao.id, declaracao);
          this.incluiEmDeclaracoes(declaracao);
          acao = 'atualizada';
        } else {
          const { index } = declaracao;

          const response = await DeclaracoesService.grava(declaracao);
          declaracao = response;
          this.incluiEmDeclaracoes(declaracao, index);
          acao = 'salva';
        }
        this.trataMensagemSucesso(declaracao.situacao, acao);
        this.defineNovaDeclaracao();
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    cancela() {
      this.limpaModal();
      this.fechaModal('declaracao');
    },
    limpaModal() {
      setTimeout(() => {
        this.mostraAtualizarRenda = false;
        this.item = new Item();
        this.declaracaoModal = new Declaracao(this.declarante);
      }, 600);
    },
    semBens(declaracao, rascunho) {
      if (this.bloqueiaEntregaPorData(declaracao, declaracao.situacao)) return;

      const sentences = [
        {
          id: 1,
          message: 'Você confirma não possuir bens a serem declarados?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: () => {
          const retificante = declaracao.situacao === 'RETIFICANTE';
          if (retificante) {
            declaracao.situacao = 'RETIFICADORA';
            declaracao.semBens = true;
            declaracao.itens = [];
            this.gravaDeclaracao(declaracao);
          } else {
            if (!declaracao.index && declaracao.index !== 0) {
              declaracao.index = this.declaracoes.indexOf(declaracao);
            }
            if (declaracao == this.declaracao) {
              this.declaracao.dataDeclaracao = moment().format('YYYY-MM-DD');
            }
            if (declaracao == this.declaracaoModal) {
              this.declaracao = declaracao;
            }
            this.declaracao.semBens = true;
            this.declaracao.itens = [];
            rascunho
              ? this.gerenciaDeclaracao('PENDENTE')
              : this.gerenciaDeclaracao('FINALIZADA');
          }
        },
        title: 'Sem Bens a Declarar',
      });
    },

    // Métodos do modal Ítem
    novoItem() {
      this.errors.clear();
      this.editaItem(this.item);
    },
    editaItem(item) {
      this.itemModal = JSON.parse(JSON.stringify(item));
      this.itemModal.index = this.declaracaoModal.itens.indexOf(item);
      this.navs[1].subtDetalhe = this.itemModal.tipo.descricao;
      this.abreModal('item');
    },
    apagaItem(item) {
      const sentences = [
        {
          id: 1,
          message: 'Deseja apagar esse item da sua lista?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: () => {
          this.declaracaoModal.itens.splice(
            this.declaracaoModal.itens.indexOf(item),
            1,
          );
        },
        title: 'Apagando item',
      });
    },
    async incluiItem() {
      const index = this.itemModal.index;
      if (this.rendaAnualDependenteModal) {
        try {
          await this.atualizaRendaDoDependente();
          await this.obtemDependenciaAtualizada(this.dependencia.id);
          this.incluiEmDeclaracaoModal(index);
          this.$root.$refs.toastr.s('Item incluído', 'Sucesso');
        } catch (error) {
          this.declaracaoModal.itens.pop(this.itemModal);

          const mensagem = ErrorHelper.trataMensagem(error);
          this.$root.$refs.toastr.e(mensagem, 'Atenção');
        }
      } else {
        this.incluiEmDeclaracaoModal(index);
        this.$root.$refs.toastr.s('Item incluído', 'Sucesso');
      }
      this.fechaModal('item');
      this.limpaModalItem();
    },
    cancelaItem() {
      this.limpaModalItem();
      this.fechaModal('item');
    },
    limpaModalItem() {
      setTimeout(() => {
        this.mostraAtualizarRenda = false;
        this.rendaAnualDependenteModal = 0;
        this.item = new Item();
        this.itemModal = new Item();
      }, 600);
    },
    incluiEmDeclaracaoModal(index) {
      if (index < 0) {
        if (this.declaracaoModal.semBens) this.declaracaoModal.semBens = false;
        this.declaracaoModal.itens.push(this.itemModal);
      } else {
        this.declaracaoModal.itens[index] = this.itemModal;
      }
    },

    // Métodos dos modais
    semBensModal() {
      this.semBens(this.declaracaoModal);
      this.fechaModal('declaracao');
    },
    abreLeiModal() {
      jQuery('#leiModal').modal('show');
    },
    abreEnviaModal(declaracao, idModal) {
      if (this.validaSemBens(declaracao)) {
        this.semBens(declaracao);
        this.fechaModal('declaracao');
        return;
      }
      jQuery(idModal).modal('show');
      this.fechaModal('declaracao');
    },
    abrePeriodoEntregaModal() {
      jQuery('#periodoAberturaModal').modal('show');
    },

    // Métodos de validação
    bloqueiaEntregaPorData(declaracao, situacao) {
      const anoAtual = moment().year();
      const ehDesseAno = declaracao.competencia.ano === anoAtual;

      if (!ehDesseAno) return false;

      const competenciaAtual = this.competencias.find(
        item => item.id === declaracao.competenciaId,
      );

      if (!competenciaAtual) {
        this.$root.$refs.toastr.w(
          'Aguarde o período de envio de declaração de bens',
          'Atenção',
        );
        return true;
      }

      const inicioLancamento =
        competenciaAtual.periodos[0].dataInicioLancamento;
      const fimLancamento = competenciaAtual.periodos[0].dataFimLancamento;
      const periodoEstahFechado = !moment().isBetween(
        inicioLancamento,
        fimLancamento,
      );

      const situacaoProibida =
        situacao === 'PENDENTE' ||
        situacao === 'EM_BRANCO' ||
        situacao === 'RETIFICANTE';

      if (periodoEstahFechado && situacaoProibida) {
        this.$root.$refs.toastr.w(
          'Aguarde a abertura do próximo período de declaração',
          'Período Fechado',
        );
        return true;
      }

      return false;
    },
    validaRendaDependente(item) {
      this.mostraAtualizarRenda = false;
      let dependencia = {};
      let rendas = [];
      if (this.existeDependente(item)) {
        dependencia = item.dependencia;
        if (this.dependenteTemRenda(dependencia)) {
          rendas = dependencia.rendas;
          if (this.rendaEstahAtualizada(rendas)) {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    existeDependente(item) {
      return item.dependencia ? true : false;
    },
    dependenteTemRenda(dependencia) {
      return dependencia.rendas.length > 0 ? true : false;
    },
    rendaEstahAtualizada(rendas) {
      const anoExercicioDaDeclaracao = this.declaracaoModal.competencia.ano - 1;
      const existeRendaDoExercicio = rendas.find(
        renda => renda.anoReferencia == anoExercicioDaDeclaracao,
      );
      return existeRendaDoExercicio ? true : false;
    },
    incluiDependente(item) {
      if (this.validaRendaDependente(item)) {
        return;
      }
      this.solicitaAtualizarRenda();
    },
    solicitaAtualizarRenda() {
      const anoExercicioDaDeclaracao = this.declaracaoModal.competencia.ano - 1;
      this.$root.$refs.toastr.w(
        `Se houver, cadastre a renda do Parceiro Econômico
                do ano de ${anoExercicioDaDeclaracao}`,
        'Atenção',
      );
      this.mostraAtualizarRenda = true;
    },
    validaJaDeclarado(declaracao) {
      const ultimaCompetencia = this.obtemUltimaCompetenciaValida();
      const ehUltimaDeclaracao =
        declaracao.competencia.id == ultimaCompetencia.id;
      const jaEntregue =
        declaracao.situacao === 'FINALIZADA' ||
        declaracao.situacao === 'RETIFICADORA';
      const aindaNaoTemCompetenciaDoAnoAtual =
        this.declaracoesOrdenadasDistintas[0].situacao === 'FINALIZADA' ||
        this.declaracoesOrdenadasDistintas[0].situacao === 'RETIFICADORA';

      return (
        (ehUltimaDeclaracao && jaEntregue) || aindaNaoTemCompetenciaDoAnoAtual
      );
    },
    obtemUltimaCompetenciaValida() {
      const segundoSemestreAnoAtual = moment().set({ month: 6, date: 1 });
      const estamosSegundoSemestreAnoAtual = moment().isAfter(
        segundoSemestreAnoAtual,
      );
      const indiceUltimaCompetencia = this.competenciasOrdenadas.length - 1;
      const ehCompetenciaSemestral =
        this.competenciasOrdenadas[indiceUltimaCompetencia].mes === 7;

      if (!estamosSegundoSemestreAnoAtual && ehCompetenciaSemestral) {
        return this.competenciasOrdenadas[indiceUltimaCompetencia - 1];
      }

      return this.competenciasOrdenadas[indiceUltimaCompetencia];
    },
    validaSemBens(declaracao) {
      return !declaracao.itens.length ? true : false;
    },
    validaItem() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.incluiItem();
        } else {
          this.$root.$refs.toastr.e(
            'Preencha ou corrija os campos em vermelho',
            'Atenção',
          );
        }
      });
    },
    validaDeclaracao(declaracao, idModal) {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.abreEnviaModal(declaracao, idModal);
        } else {
          this.$root.$refs.toastr.e(
            'Preencha ou corrija o campo de Justificativa',
            'Atenção',
          );
        }
      });
    },

    // Métodos de montagem de tela
    montaTelaDeclaracoes() {
      const tipo =
        this.autenticado.tipo === 'CARGO_LIVRE_PROVIMENTO' ||
        this.autenticado.tipo === 'CARGO_ELETIVO'
          ? 'semestral'
          : 'anual';

      this.filtraCompetencias(tipo);
      this.listaDeclaracoesPendentes();
      this.defineNovaDeclaracao();
      this.carregando = false;
      this.mostraModalExplicacao();
    },
    filtraCompetencias(tipoPeriodo) {
      if (tipoPeriodo === 'anual') {
        const filtrado = this.competencias.filter(
          competencia => competencia.mes === 1,
        );
        this.competencias = filtrado;
      }
    },
    listaDeclaracoesPendentes() {
      let declaracaoPendente = {};
      const anoAtual = moment().year();
      const anoInicioAtividade = moment(
        this.autenticado.dataInicioAtividade,
      ).year();
      let ultimoAnoBase =
        this.declaracoesOrdenadasDistintas[0].competencia.ano - 1;
      const ultimoMesCompetencia = this.declaracoesOrdenadasDistintas[0]
        .competencia.mes;
      const nuncaDeclarou = !this.declaracoes.length;
      const ativoHaMaisDeUmAno = anoInicioAtividade < anoAtual;

      if (nuncaDeclarou && ativoHaMaisDeUmAno) {
        ultimoAnoBase = anoInicioAtividade - 1;
      }
      const competenciasPendentes = this.listaCompetenciasPendentes(
        ultimoAnoBase,
        ultimoMesCompetencia,
      );

      competenciasPendentes.map(competenciaCorrente => {
        declaracaoPendente = new Declaracao(this.declarante);
        declaracaoPendente.competencia = competenciaCorrente;
        declaracaoPendente.dataDeclaracao = null;
        this.declaracoes.push(declaracaoPendente);
      });
    },
    listaCompetenciasPendentes(ultimoAnoBase, ultimoMesCompetencia) {
      let competenciasPendentes = [];

      const anoAtual = moment().year();
      const segundoSemestreAnoAtual = moment().set({ month: 6, date: 1 });
      const estamosSegundoSemestreAnoAtual = moment().isAfter(
        segundoSemestreAnoAtual,
      );
      const ultimoAnoMes =
        String(ultimoAnoBase + 1) + String(ultimoMesCompetencia);

      if (this.competenciasOrdenadas.length) {
        this.competenciasOrdenadas.map(competencia => {
          const competenciaAnoMes =
            String(competencia.ano) + String(competencia.mes);
          const ehUltimoAnoSemestral =
            competencia.ano === anoAtual && competencia.mes === 7;

          if (competenciaAnoMes > ultimoAnoMes && !ehUltimoAnoSemestral) {
            competenciasPendentes.push(competencia);
          }

          if (ehUltimoAnoSemestral && estamosSegundoSemestreAnoAtual) {
            competenciasPendentes.push(competencia);
          }
        });
      }

      return competenciasPendentes;
    },
    defineNovaDeclaracao() {
      const declaracoesAtrasadas = this.declaracoesOrdenadasDistintas.filter(
        declaracao =>
          declaracao.situacao == 'EM_BRANCO' ||
          declaracao.situacao == 'PENDENTE',
      );
      if (declaracoesAtrasadas.length) {
        this.declaracao = declaracoesAtrasadas[declaracoesAtrasadas.length - 1];
      }
    },
    incluiEmDeclaracoes(declaracao, index) {
      if (!index && index !== 0) {
        index = this.declaracoes.findIndex(
          element => element.id === declaracao.id,
        );
      }

      this.$set(this.declaracoes, index, declaracao);
    },

    // Métodos de requisições
    async listaDeclaracoes() {
      this.carregando = true;

      try {
        const response = await DeclaracoesService.lista();
        if (response && response.content) {
          this.declaracoes = response.content;
        }
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    async listaItens(id) {
      this.carregandoItens = true;

      try {
        this.declaracaoModal = await DeclaracoesService.obtem(id);
        if (!this.declaracaoModal.itens) {
          this.declaracaoModal.itens = [];
        }
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregandoItens = false;
      }
    },
    async listaTiposBens() {
      try {
        const tiposBens = await TiposBensService.lista();
        this.tiposBens = tiposBens;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async listaDependencias() {
      try {
        const dependencias = await DependenciasService.lista();
        this.dependencias = dependencias.content;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async listaCompetencias(evento) {
      try {
        const competencias = await MesesCompetenciasService.listaPorEvento(
          evento,
        );
        this.competencias = competencias.content;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async atualizaRendaDoDependente() {
      let renda = new Renda();
      renda.valor = this.rendaAnualDependenteModal;
      renda.anoReferencia = this.declaracaoModal.competencia.ano - 1;
      this.dependencia = this.itemModal.dependencia;
      this.dependencia.dependente.cpf = StringHelper.limpaFormato(
        this.dependencia.dependente.cpf,
      );
      this.dependencia.rendas.unshift(renda);
      try {
        await DependenciasService.atualiza(
          this.dependencia.id,
          this.dependencia,
        );
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async obtemDependenciaAtualizada(id) {
      try {
        const response = await DependenciasService.lista();
        const dependencias = response.content;
        const dependencia = dependencias.find(item => item.id === id);
        this.itemModal.dependencia = { ...dependencia };
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    mostraModalExplicacao() {
      if (!sessionStorage.mostraLei) {
        // if (
        //   !this.bloqueiaEntregaPorData(
        //     this.declaracoesOrdenadasDistintas[0],
        //     this.declaracoesOrdenadasDistintas[0].situacao,
        //   )
        // )
        this.abreLeiModal();

        sessionStorage.setItem('mostraLei', true);
      }
    },
    fazRequisicoes() {
      Promise.all([
        this.listaCompetencias('DECLARACAO_DE_BENS'),
        this.listaDeclaracoes(),
        this.listaTiposBens(),
        this.listaDependencias(),
      ]).then(() => this.montaTelaDeclaracoes());
    },
    charCount() {
      this.totalCharacter = this.declaracaoModal.justificativa.length;
    },
  },
  components: {
    Botao,
    SideModal,
    EscondeDiv,
    TableLoader,
  },
  created() {
    this.autenticado = this.$store.state.usuarioLogado.funcionarios[0];
    this.declarante.id = this.autenticado.idPessoa;
    this.declarante.nome = this.autenticado.nome;
    this.item = new Item();
    this.itemModal = new Item();
    this.declaracao = new Declaracao(this.declarante);
    this.declaracaoModal = new Declaracao(this.declarante);

    this.fazRequisicoes();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.characterAlert {
  color: red;
}
</style>



// WEBPACK FOOTER //
// index.vue?cb7748d2